module.exports = __webpack_public_path__ + "static/media/whistledog-mb-en.974be6b2.jpg";